// Question informations methods

// Carrega um item no state
export const loadInformation = (itemKey, stateListKey, component) => {
    const objectList = component.state[stateListKey] || [];
    let output = {};

    if (objectList.length > 0) {
        var item = objectList.find(x => { return x.key == itemKey });
        output = item !== undefined ? item : {};
    }

    return output;
}

//Carrega as informações de um campo específico no state
export const itemFieldValue = (entityKey, field, stateListKey, component) => {

    let output = undefined;


    var item = loadInformation(entityKey, stateListKey, component);

    output = item !== undefined ? item[field] : undefined;

    return output;
}

//Tratativas para mudar os valores de um campo específico em lote
export const handleChangeAll = (itemKey, event, fieldListStateKey, stateListKey, component, searchItemInput) => {
    const { value, checked, type } = event.target;

    handleItemChange(itemKey, event, fieldListStateKey, component);

    const targetName = event.target.getAttribute('data-field-target-name');
    const changeValue = type == "checkbox" ? checked : value;

    const stateList = component.state[stateListKey] || [];

    let targetList = stateList;
    
    if (searchItemInput) {

        targetList = stateList.filter(x => x.key.includes(searchItemInput));
    }
    targetList.map((e, i) => {
        handleFieldChange(e.key, targetName, changeValue, stateListKey, component);
    });

}

//Tratativas para quando um campo muda de valor (geral)
export const handleItemChange = (key, event, stateListKey, component) => {
    const { value, checked, type } = event.target;
    const name = event.target.getAttribute('data-field-name');

    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, stateListKey, component);
}


//Tratativas para quando um campo muda de valor (editor de texto)
export const handleItemDateTimeChange = (key, formField, dateTimeValue, stateListKey, component) => {
    handleFieldChange(key, formField, dateTimeValue, stateListKey, component);
}

//Tratativas para quando um campo muda de valor (editor de texto)
export const handleItemEditorChange = (key, formField, editor, stateListKey, component) => {
    const changeValue = editor.getData();

    handleFieldChange(key, formField, changeValue, stateListKey, component);
}

//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, stateListKey, component) => {
    var item = loadInformation(key, stateListKey, component);

    item[field] = value;

    const itemList = changeStateList(item, stateListKey, component);

    component.setState({
        [stateListKey]: itemList
    });
}

//Prapara o objeto do state para a atualização com as informações
export const changeStateList = (targetInformation, stateListKey, component, remove = false) => {

    let stateList = component.state[stateListKey] || [];

    let existing = stateList.filter(x => x.key == targetInformation.key)[0];
    let otherItems = stateList.filter(x => x.key != targetInformation.key);
    let outputItem = targetInformation;


    if (existing && remove) {
        if (existing.id) {
            outputItem = { ...targetInformation, isDeleteRequested: true, key: 'delete-requested-' + new Date().getTime() };
        } else {
            outputItem = undefined;
        }
    }
    if (outputItem) {
        return [...otherItems, outputItem];
    } else {
        return otherItems;
    }
}


// ----------------------------------------


const stateListHandler = {
    loadInformation,
    itemFieldValue,
    handleItemChange,
    handleItemEditorChange,
    handleItemDateTimeChange,
    handleChangeAll,
    changeStateList
}

export default stateListHandler;